module.exports = __webpack_public_path__ + "img/icon5.8336ed0f.jpg";